module.exports = __webpack_public_path__ + "img/xdyl.8c24fd86.png";